import Vue from 'vue';
import axios from 'axios';
Vue.prototype.$http = axios;

if (typeof Storage !== "undefined") {
  let UserToken = localStorage.getItem('token');
  if (UserToken) {
    Vue.prototype.$http.defaults.headers.common['Authorization'] = UserToken;
  }
}

Vue.prototype.$http.defaults.baseURL = 'https://api-server.glamourboutique.uz/api/';

// Vue.prototype.$http.defaults.baseURL = 'http://127.0.0.1:8002/api/';

Vue.prototype.$http.interceptors.request.use(
  (config) => {
    return config
  },
  (error) => {
    return Promise.reject(error);
  }
);

Vue.prototype.$http.interceptors.response.use(
  (response) => {
    return response;
  },
  (error) => {
    if (error.response.status == '401') {

    }
    if (error.response.status == '429') {

    }
    if (error.response.status == '500') {

    }
    if (error.response.status == '422') {

    }
    return Promise.reject(error);
  }
);

export default Vue.prototype.$http;
